import React from 'react';

import { Button } from '@shared/components/bootstrap';

import { useQA } from '@admin/hooks/use_qa';
import { client } from '@admin/libraries/apollo';
import { Order, OrderStateEnum, OrderTypeEnum, useOrderReturnRouteMutation } from '@admin/schema';

export const OrderReturnRouteButton: React.FC<{
  order: Pick<Order, 'type' | 'id' | 'state'>;
}> = ({ order }) => {
  const qa = useQA();
  const [execute, { loading }] = useOrderReturnRouteMutation({
    client,
    variables: { orderID: String(order.id) },
  });

  const routeable = order.state === OrderStateEnum.Approved && order.type === OrderTypeEnum.Return;
  if (!qa || !routeable) return null;

  const route = async () => {
    await execute();
    location.reload();
  };

  return (
    <Button loading={loading} kind="warning" onClick={route}>
      Auto-Route Return
    </Button>
  );
};
